import { useI18n } from 'vue-i18n'

import useBlProviders from '@/composables/providers/useBlProvider'
import WorksQualityNormsDt from '@/services/dataTransferModules/worksQualityNormsDt'

const worksQualityNormsDt = new WorksQualityNormsDt()

export default function useWorksQualityNorms() {
	const { t: $t } = useI18n()

	const {
		loadEntityFlags: flags,

		entities: worksQualityNorms,
		getEntities: getWorksQualityNorms,

		entity: worksQualityNorm,
		getEntity: getWorksQualityNorm,

		createEntity: createWorksQualityNorm,
		updateEntity: putWorksQualityNorm,
		patchEntity: updateWorksQualityNorms,
		deleteEntity: deleteWorksQualityNorm,
	} = useBlProviders(worksQualityNormsDt, {
		showErrorNotificationForLoadingAllEntities: true,
		errorNotificationTextForLoadingAllEntities: $t('Error while loading quality norms'),

		showErrorNotificationForLoadingOneEntity: true,
		errorNotificationTextForLoadingOneEntity: $t('Works quality norms loading error'),

		showErrorNotificationForCreatingEntity: true,
		errorNotificationTextForCreatingEntity: $t('Error when creating a quality norms'),

		showErrorNotificationForUpdatingEntity: true,
		errorNotificationTextForUpdatingEntity: $t('Error editing the works quality norms'),

		showErrorNotificationForDeletingEntity: true,
		errorNotificationTextForDeletingEntity: $t('Failed to delete work quality norm'),
	})

	const defaults = {
		creatingWorksQualityNorm: {
			name: '',
			quality_metric: '',
			optimal_value: '',
			min_value: '',
			max_value: '',
			work: '',
		},
		fieldsToPatch: ['name', 'quality_metric', 'optimal_value', 'min_value', 'max_value', 'work'],
	}

	return {
		flags,
		defaults,
		worksQualityNorms,
		worksQualityNorm,
		getWorksQualityNorms,
		getWorksQualityNorm,
		createWorksQualityNorm,
		putWorksQualityNorm,
		updateWorksQualityNorms,
		deleteWorksQualityNorm,
	}
}
